<template>
  <div class="home-style">
    <rSwiper v-if="pcImgList.length > 0" ref="swiperDOM" class="swiper " @loadEnd="funLoadEnd"
      @transitionend="funTransitionend" :fast="true">
      <!-- <rSlide>
        <div class="box">
          <img src="../../assets/image/home/homebanner4.png" alt="" style="width: 100%;height: 100%">
        </div>
      </rSlide>
      <rSlide>
        <div class="box box4">
          <img src="../../assets/image/home/homebanner3.png" alt="" style="width: 100%;height: 100%">
        </div>
      </rSlide>
      <rSlide>
        <div class="box box3">
          <img src="../../assets/image/home/homebanner2.png" alt="" style="width: 100%;height: 100%">
        </div>
      </rSlide>
      <rSlide>

        <div class="box">
          <img src="../../assets/image/home/homebanner1.png" alt="" style="width: 100%;height: 100%">
        </div>
      </rSlide> -->

      <rSlide v-for="(item, index) in pcImgList" :key="index">
        <div class="box" :class="'box' + (index + 1)">
          <img :src="item" alt="" style="width: 100%;">
        </div>
      </rSlide>
    </rSwiper>
    <rSwiper v-else ref="swiperDOM" :indicator="false" :indicatorFlash="false" class="swiper" @loadEnd="funLoadEnd"
      @transitionend="funTransitionend" :fast="true">

      <rSlide>
        <div class="box box4">
          <img src="../../assets/image/home/homebanner3.png" alt="" style="width: 100%;height: 100%">
        </div>
      </rSlide>



    </rSwiper>
  </div>
  <div class="home-style-phone">
    <rSwiper v-if="phoneImgList.length > 0" ref="swiperDOM" class="swiper" @loadEnd="funLoadEnd"
      @transitionend="funTransitionend" :autoPlay="false">
      <!-- :fast="true" -->
      <!-- <rSlide>
        <div class="box">
          <img src="../../assets/image/home/home_phone_carousel4.png" alt="" style="width: 100%;height: 100%">
        </div>
      </rSlide>
      <rSlide>
        <div class="box box2">
          <img src="../../assets/image/home/home_phone_carousel3.png" alt="" style="width: 100%;height: 100%">
        </div>
      </rSlide>
      <rSlide>
        <div class="box box3">
          <img src="../../assets/image/home/home_phone_carousel1.png" alt="" style="width: 100%;height: 100%">
        </div>
      </rSlide>
      <rSlide>
        <div class="box box4">
          <img src="../../assets/image/home/home_phone_carousel2.png" alt="" style="width: 100%;height: 100%">
        </div>
      </rSlide> -->
      <rSlide v-for="(item, index) in phoneImgList" :key="index">
        <div class="box" :class="'box' + (index + 1)">
          <img :src="item" alt="" style="width: 100%;">
        </div>
      </rSlide>
    </rSwiper>
    <rSwiper v-if="else" ref="swiperDOM" class="swiper" @loadEnd="funLoadEnd" @transitionend="funTransitionend"
      :autoPlay="false">
      <!-- :fast="true" -->

      <rSlide>
        <div class="box box4">
          <img src="../../assets/image/home/home_phone_carousel2.png" alt="" style="width: 100%;height: 100%">
        </div>
      </rSlide>

    </rSwiper>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { rSlide, rSwiper } from 'r-swiper'
import { getFilterList } from "@/api/index"
import banner from "../../assets/image/home/homebanner4.png"

const nowIndex = ref(0) // 当前下标

const swiperDOM = ref(null) // Dom元素
const loadingPcImgList = [banner]
const pcImgList = ref([])
const phoneImgList = ref([])

const getData = async () => {
  let params = {
    page: 1,
    pageSize: 10000,
    sortField: "numberf5429dca",
    isAsc: true,
    worksheetId: "6805ab05ec5e343d1c9824fa",
  }
  const res = await getFilterList(params)
  if (res.code === 200 && res.data && res.data.length > 0) {
    res.data.forEach(item => {
      if (item["picture-upload8f5a8ab2"] && item["picture-upload8f5a8ab2"].length > 0) {
        pcImgList.value.push(item["picture-upload8f5a8ab2"][0].url)
      }
      if (item["picture-uploadeda3901c"] && item["picture-uploadeda3901c"].length > 0) {
        phoneImgList.value.push(item["picture-uploadeda3901c"][0].url)
      }
    })
    console.log(pcImgList.value);


  }
}

onMounted(() => {
  getData()
})

/**
 * 2023-12-18 08:52:05 Ywr
 * 初始化加载完成反馈函数
*/
const funLoadEnd = () => {
  console.log('loading - success');
  // changePage(1, true)
}

/**
 * 2023-08-12 19:23:06 Ywr
 * 切换页面完成反馈函数
 * @param {Number} i 当前下标
*/
const funTransitionend = (i) => {
  nowIndex.value = i
  console.log('当前下标', nowIndex.value)
}



</script>

<style scope lang="less">
@media screen and (max-width: 800px) {
  .home-style {
    display: none;
  }

  .home-style-phone {
    display: block;
  }
}



@media screen and (min-width: 800px) {
  .home-style {

    display: block;
  }

  .home-style-phone {
    display: none;
  }
}

.home-style {
  width: 100%;
  height: 100%;
  aspect-ratio: 960 / 313;

  .box {
    width: 100vw;
    height: 100%;
    aspect-ratio: 960 / 313;
    position: relative;
    // background: url('../../assets/image/home/homeCarousel1.png') no-repeat;

    .box-content {
      position: absolute;
      color: #fff;
      z-index: 999999;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -70%);
      font-family: 'PuHuiTi';
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .box-content-title {
        font-size: 60px;
        color: rgba(255, 255, 255, 1);
        font-weight: 700;
      }

      .box-content-jianjie {
        margin-top: 20px;
        font-size: 24px;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}

.home-style-phone {
  width: 100%;
  height: 100%;
  aspect-ratio: 828 / 1145;

  .box {
    width: 100vw;
    height: 100%;
    aspect-ratio: 828 / 1145;
    position: relative;
    // background: url('../../assets/image/home/homeCarousel1.png') no-repeat;

    .box-content {
      position: absolute;
      color: #fff;
      z-index: 999999;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -70%);
      font-family: 'PuHuiTi';
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .box-content-title {
        width: 100%;
        font-size: 36px;
        text-align: left;
        margin-left: 20px;
        letter-spacing: 3px;
        color: rgba(255, 255, 255, 1);
      }

      .box-content-jianjie {
        font-size: 24px;
        display: flex;
        align-items: baseline;
        color: rgba(255, 255, 255, 1);
        letter-spacing: 3px;

        .box-content-jianjie-left {
          font-size: 52px;
          color: rgba(35, 197, 208, 1);
        }
      }
    }
  }
}
</style>
